import React from 'react';
import {useDispatch} from "react-redux";

const AdmissionList_Item_ManagerCustomUI_AdmissionStatus = ({admission, customUI}) => {
    const dispatch = useDispatch();
    const uiData = admission.manager_customUI[customUI.id];

    if(!uiData || !uiData.status) {
        return <_Btn_Grey />
    }

    switch (uiData.status) {
        case 1:
            return <_Btn_Grey />
        case 2:
            return <_Btn_Blue />
        case 3:
            return <_Btn_Green />
    }
}

const _Btn_Grey = ({children = '-'}) => {
    return <button className="btn btn-group-table-button btn-secondary">{children}</button>;
}
const _Btn_Blue = ({children = '-'}) => {
    return <button className="btn btn-sm btn-primary">{children}</button>;
}
const _Btn_Green = ({children = '-'}) => {
    return <button className="btn btn-sm btn-gray10 lifehouse-button-green">{children}</button>;
}


export default AdmissionList_Item_ManagerCustomUI_AdmissionStatus;